import * as React from 'react'

type Props<T extends Element> = {
  enabled: boolean
  onIntersect: IntersectionObserverCallback
  threshold?: number
  rootMargin?: string
  target: React.MutableRefObject<T>
}
const useIntersectionObserver = <T extends Element>({
  enabled,
  target,
  onIntersect,
  threshold = 0,
  rootMargin = '0px',
}: Props<T>) => {

  React.useEffect(() => {
    if (!enabled) {
      return
    }
    const observer = new IntersectionObserver(onIntersect, {
      rootMargin,
      threshold,
    })
    const current = target.current
    observer.observe(current)
    return () => {
      observer.unobserve(current)
    }
  }, [])
}
export default useIntersectionObserver
